import script from "./ChangeSize.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeSize.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeSize.vue?vue&type=style&index=0&id=4286139e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4286139e"]])

export default __exports__